import {
  lg,
  cloneDeep,
  util,
  isCorrectVal,
  isDate
} from 'utils';
import NProgress from 'nprogress';
import $http from '$http';
export default {
  methods: {
    // 查看物流情况api/UserOrder/GetStockByOrderId
    GetStockByOrderId(OrderId) {
      let params = {
        Sid: this.$store.state.sysSid,
        Session: this.$store.state.sysSession,
        OrderId: OrderId
      };
      this.loading = true;
      $http.get("api/UserOrder/GetStockByOrderId", params).then(res => {
        let {
          Data,
          Cnt
        } = res.data;
        this.loading = false;
        util.doResult(this, res, () => {
          this.formData = Data
          this.ConsigneeInfo = this.formData.ConsigneeInfo
          console.log(this.formData[0].LogisticsId)
          if (this.formData[0].LogisticsId > 0) {
            this.GetExpress(this.formData[0].LogisticsId, this.formData[0].LogisticsCode)
          }
        });
      });
    },
    //获取物流信息 http://interface.iqeq.cn/api/Express/GetExpress
    GetExpress(LogisticsId, ExpNo) {
      let params = {
        LogisticsId: LogisticsId,
        ExpNo: ExpNo
      };
      this.loading = true;
      $http.getV2("http://interface.iqeq.cn/api/Express/GetExpress", params).then(res => {
        let {
          Data,
          Cnt
        } = res.data;
        this.loading = false;
        util.doResult(this, res, () => {
          console.log(Data)
          this.Express = Data
        });
      });
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/Family/OrderList/stockDialog/services.js